
<template>
    <svg :width="size" :height="size"  viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0001 14.6666H29.3334V17.3333H20.0001V14.6666ZM21.3334 20H29.3334V22.6666H21.3334V20ZM18.6667 9.33329H29.3334V12H18.6667V9.33329ZM5.33341 25.3333H18.6667V24C18.6667 20.324 15.6761 17.3333 12.0001 17.3333H9.33342C5.65741 17.3333 2.66675 20.324 2.66675 24V25.3333H5.33341ZM10.6667 16C13.3267 16 15.3334 13.9933 15.3334 11.3333C15.3334 8.67329 13.3267 6.66663 10.6667 6.66663C8.00675 6.66663 6.00008 8.67329 6.00008 11.3333C6.00008 13.9933 8.00675 16 10.6667 16Z" fill="currentColor"/>
</svg>
  </template>
  
  <script>
  export default {
    props: {
      size: { type: String }
    }
  }
  </script>